import React, { useRef, useState } from "react";
import "./UserAccountTransfers.scss";
import LanguageIcon from "@mui/icons-material/Language";
import CustomForm from "../../UI/CustomForm/CustomForm";
import Select from "../../UI/Select/Select";
import Input from "../../UI/Input/Input";
import BaseButton from "../../UI/BaseButton/BaseButton";
import { useSelector } from "react-redux";
import { getContactList, getCustomerAccount, saveExternalContact, sendDeposit, sendSMSorEmail } from "../../../util/API/transfer";
import { useEffect } from "react";
import PinPad from "../../PinPad/PinPad";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import { Stack, Box, CircularProgress } from "@mui/material";
import { countryList } from "../../../constants/countrylist";
import { decodeHtmlEntities, getErrorMessage, getErrorMessage2, setAsArray } from "../../../util/utilfunctions/utilFunctions";


function LocalTransfers({ selectedUserData }) {
  const [inputValue, setInputValue] = useState("");
  const [senderName, setSenderName] = useState(selectedUserData ? `${selectedUserData?.User?.firstName} ${selectedUserData?.User?.lastName}` : "");
  // const [senderName, setSenderName] = useState("NCS CONSUMER1 OG [3893]");
  const [selectedOption, setSelectedOption] = useState("");
  const [fee, setFee] = useState(0.0);
  const [total, setTotal] = useState(0.0);
  const [customerInformation, setCustomerInformation] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [formValues, setFormValues] = useState();
  const [recipientName, setRecipientName] = useState("");
  const [changeSelect, setChangeSelect] = useState(false);
  const [alert, setAlert] = useState({
    severity: "error",
    message: "",
    header: "",
    show: false,
    type: "",
    additionalInformation: {}
  });
  const [showPinPad, setShowPinPad] = useState(false);
  const [receiptID, setReceiptID] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [txcode, setTxCode] = useState("");
  const [claimcode, setClaimCode] = useState("");
  const contactRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  let isOperator = sessionStorage.getItem("isOperator");
  let pin = sessionStorage.getItem("pin");
  const parentuserid = sessionStorage.getItem("parentuserid");
  let configVariables = useSelector((state) => state.config.baseConfig);
  let isAutoRetry;

  const user = useSelector((state) => state.usersList.userID);
  let agent = JSON.parse(sessionStorage.getItem("user")).payload.body;

  // Dummy function to calculate fee, this should be replaced with actual logic
  const calculateFee = () => {
    // Set static fee for demonstration purposes
    const calculatedFee = 0.0;
    setFee(calculatedFee);
    if (inputValue === "") {
      setTotal(0.0);
      return;
    }
    setTotal(parseFloat(inputValue) - calculatedFee);
  };

  const getAccounts = async () => {
    const response = await getCustomerAccount(user['User'].id);
    if(response?.callStatus == "1") {
      const records = response?.ServiceData?.record?.filter(
        (record) => record?.Vtransfersourcepis?.piid === "229"
      );
  
      // Filter out duplicates based on unique identifiers (e.g., account ID)
      const uniqueRecords = records?.filter(
        (record, index, self) =>
          index === self?.findIndex(
            (r) => r?.Vtransfersourcepis?.acctID === record?.Vtransfersourcepis?.acctID
          )
      );
      
      setCustomerInformation(uniqueRecords);
    }
  };

  const getContacts = async () => {
    const response = await getContactList(user['User'].id);
    const blockedContactTypes = ["RIA", "BPI", "WesternUnion", "MoneyGram", "EMER"];
    const contacts = setAsArray(response.ServiceData.record);
    // const filtered = contacts.filter(item => {
    //   try {
    //     const otherObj = JSON.parse(item.Usercontactlistexternal.other.replace(/&(amp;)*quot;/g, '"'));
    //     return !blockedContactTypes.includes(otherObj.type);
    //   } catch (e) {
    //     return false;
    //   }
    // });

    const filtered = contacts.filter(item => {
      try {
        let otherObj;
        
        // Check if 'other' is a valid JSON string
        if (item.Usercontactlistexternal.other.startsWith("{") && item.Usercontactlistexternal.other.endsWith("}")) {
          // Attempt to parse the JSON string
          otherObj = JSON.parse(item.Usercontactlistexternal.other.replace(/&(amp;)*quot;/g, '"'));
        } else {
          // If it's not JSON, assume it's a delimited string and split it
          const otherFields = item.Usercontactlistexternal.other.split("|");
          // Map the fields into an object with key-value pairs (custom structure)
          otherObj = {
            address: otherFields[0],
            email: otherFields[1],
            country: otherFields[2],
            phone: otherFields[3]
          };
        }
        
        // Now check if the contact's type is in the blocked types array
        return !blockedContactTypes.includes(otherObj.type);
        
      } catch (e) {
        // Handle any error that occurs, for example invalid JSON or split issues
        console.error("Error parsing 'other' field:", e);
        return false;  // Exclude this item if there's an error
      }
    });
    setContacts(filtered);
  };

  useEffect(() => {
    getAccounts();
    getContacts();
    setChangeSelect(true)
  }, []);

  const options = customerInformation.map((record) => ({
    key: record.Vtransfersourcepis.acctID,
    value: record.Vtransfersourcepis.friendlyname,
    label: record.Vtransfersourcepis.friendlyname + " - " + record.Vtransfersourcepis.currcode + " " + record.Vtransfersourcepis.balance
  }));

  useEffect(() => {
    if (options) {
      setSelectedOption(options[0]?.value)
    }
  }, [options])

  const handleContactChange = (selectedContactId) => {
    let selectedContact;
  if (Array.isArray(contacts)) {
    selectedContact = contacts.find(
      (contact) => contact.Usercontactlistexternal.id === selectedContactId
    );
  } else if (typeof contacts === 'object' && contacts.Usercontactlistexternal) {
    // If it's a single object, check if the ID matches
    if (contacts.Usercontactlistexternal.id === selectedContactId) {
      selectedContact = contacts;
    }
  }
  
    if (selectedContact) {
      try {
        const rawOtherData = selectedContact.Usercontactlistexternal;
  
        let otherData = {};
  
        // Check if the data is in JSON format (contains "{"), otherwise split by pipe (|)
        if (rawOtherData?.other.trim().startsWith("{")) {
          otherData = JSON.parse(rawOtherData?.other.replace(/&amp;quot;/g, '"'));
        } else {
          // Split the pipe-separated data
          const [recipientaddress, recipientemail, recipientctry, recipientphone] =
            rawOtherData.other.split("|");
  
          otherData = {
            recipientfname: rawOtherData.firstName,
            recipientlname: rawOtherData.lastName,
            recipientaddress,
            recipientctry,
            recipientemail,
            recipientphone,
          };
        }
  
        const {
          recipientfname,
          recipientlname,
          recipientaddress,
          recipientctry,
          recipientemail,
          recipientphone,
        } = otherData;
  
        setFormValues({
          firstName: selectedContact.Usercontactlistexternal.firstName || recipientfname || "",
          lastName: selectedContact.Usercontactlistexternal.lastName || recipientlname || "",
          address: recipientaddress || "",
          recipientctry: recipientctry || "", // Only available in JSON format
          email: recipientemail || "",
          phoneNo: recipientphone || "",
        });

      } catch (error) {
        console.error("Failed to parse contact information:", error);
  
        setFormValues();
      }
    } else {
      setFormValues({
        firstName: "",
        lastName: "",
        address: "",
        recipientctry: "",
        email: "",
        phoneNo: "",
      });
    }
  };

  useEffect(() => {
    if (formValues) {
      setChangeSelect(false)
    }
  }, [formValues]);

  // Function to handle the deposit action
  const handleAddExternalContact = async(data, formData) => {

    if (!data.firstName || !data.lastName) {
      setAlert({
      show: true,
      message: "Please fill in the first and last name before adding a contact",
      severity: "error",
      header: "Error!",
    })

    return;
  }

    try{
      const response = await saveExternalContact(
        data.address,
        user['User'].id,
        data.firstName,
        data.lastName,
        data.email,
        data.phoneNo,
        data.recipientctry
        
      ).then((response) => {
          setAlert({
            show: true,
            message: "Contact Added Successfully",
            severity: "success",
            header: "Congratulations!",
            type: "savecontact"
          }) 

          setFormValues();
      });
    }
    catch(error){
      setAlert({
        show: true,
        message: "Contact was not added",
        severity: "error",
        header: "Error!",
      })
    }
    getContacts();
  };

  const handleReceipt = () => {
    // window.open("https://dev2.4pay.ca/portal/www/php/Workflows/mod_genreceipt.php?type=transfer&id=" + receiptID, "_blank");
    window.open(
      configVariables.baseURL + 
      configVariables.receiptExtension + 
      "/mod_genreceipt.php?type=transfer&id=" + 
      receiptID, "_blank"
    );
  }

  const handleSendDeposit = async(event, pin) => {
    event.preventDefault();
    setReceiptID("");

    if (!inputValue) {  
      setAlert({
        show: true,
        message: "Please enter a value to be deposited",
        severity: "error",
        header: "Error",
        type: "error"
      })
      return;
    }

    if (!recipientName) {
      setAlert({
        show: true,
        message: "Please link a contact before processing the transaction",
        severity: "error",
        header: "Error",
        type: "error"
      })

      return;
    }

    try {
      setIsLoading(true);
      const response = await sendDeposit(
        user['User'].id,
        customerInformation.filter((record) => record.Vtransfersourcepis.friendlyname === selectedOption)[0].Vtransfersourcepis.currcode,
        inputValue,
        pin,   //pin,
        customerInformation.filter((record) => record.Vtransfersourcepis.friendlyname === selectedOption)[0].Vtransfersourcepis.id,
        customerInformation.filter((record) => record.Vtransfersourcepis.friendlyname === selectedOption)[0].Vtransfersourcepis.piid,
        formValues.phoneNo,
        "sent money to",   // comments,
        formValues.firstName + " " + formValues.lastName,
        formValues.email,
        user['User'].firstName + " " + user['User'].lastName,
        user['User'].address1 + ", " + user['User'].cityname,
        countryList.filter((record) => record.value === user['User'].countryid)[0]?.label, //user['User'].countryid,
        user['User'].zip,
        user['User'].telephoneno,
        user['Useremailaccount'].emailAccount,
        formValues.address, //recipient address
        formValues.recipientctry,
        "",   // recipientcountrydat,
        total,
        "",   // txdate,
        pin,
        agent['User'].id, // agent
        agent['User'].firstName, // agent
        agent['User'].lastName, // agent
        parentuserid,
        isOperator
      )

      if (response.callStatus == "1") {
        setAlert({
          show: true,
          message: "Transfer Completed",
          severity: "success",
          header: "Congratulations!",
          type: "localtransfer",
          additionalInformation: {
            "Transaction Code": response.txcode,
            "Confirm Code": response.confirmcode,
          }
        })
        setTxCode(response.txcode);
        setClaimCode(response.confirmcode);
        setReceiptID(response.transferid)
        setDisabled(true);
        setInputValue("");
        setRecipientName("");

        if (pinConfiguration === "once") {
          sessionStorage.setItem("pin", pin);
        }
        
      }
      else {
        const message = getErrorMessage2(response, isAutoRetry = true);
        setAlert({
          show: true,
          message: "Transfer was unsuccessful.\n" + message,
          severity: "error",
          header: "Error!",
          type: "",
        })
      }
    }
    catch (error) {

    } finally {
      setIsLoading(false);
    }

    getAccounts();
  }

  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);

  const handleLinkContact = () => {
    // Logic to link contact
    setRecipientName(formValues['firstName'] + " " + formValues['lastName']);
  }

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    handleSendDeposit(event, PIN);
    setShowPinPad(false);
  };

  const handleSMSEmail = async(type, setMessage) => {
    setMessage("");
    const response = await sendSMSorEmail(
      agent['User'].id,
      formValues.email,
      formValues.phoneNo,
      user['User'].id,
      user['User'].countryid,
      type,
      txcode,
      claimcode,
      user['User'].firstName + " " + user['User'].lastName,
    );
    if (response.callStatus === "1") {
      if (type === 0) {
        setMessage("Message Sent Successfully");
      }
      else {
        setMessage("Email Sent Successfully");
      }
    }
    else {
      setMessage("Message/Email Not Sent");
    }
  }

  const handleTransferButton = () => {
    if (!inputValue || parseFloat(inputValue) === 0) {
      setAlert({
        show: true,
        message: "Please enter a value greater than 0 to be deposited",
        severity: "error",
        header: "Error",
        type: "error"
      })
      return;
    }

    if (!recipientName) {
      setAlert({
        show: true,
        message: "Please link a contact before processing the transaction",
        severity: "error",
        header: "Error",
        type: "error"
      })

      return;
    }

    setShowPinPad(true);
  }

  return (
    <Box className="local-transfers-container">
      <Box className="d-flex justify-content-center gap-3 align-items-center">
        <LanguageIcon />
        <Box className="header">Local Transfer Funds</Box>
      </Box>

      {isLoading == true ? (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                overflow: "hidden",
            }}
        >
            <CircularProgress />
        </Box>
      ) : (
          <Box className="local-transfers-form row">
            <Box className="receiver-details col-6">
              <CustomForm 
                formName={"sendlocal1"} 
                onSubmit={formValues && formValues.firstName !== "" ? handleLinkContact : handleAddExternalContact}
                formValues={formValues}
                buttonText={formValues && formValues.firstName !== "" ? "Link Contact" : "Add Contact"}
                loadingButtonText={"Adding User ..."}
                option={contacts}
                fieldRendererType={"transfer"}
                handleContactChange={handleContactChange}
                resetData={true}
                ref={contactRef}
              />
            </Box>
            <Box className="sender-details col-6">
              {" "}
              <Box className="customer-deposit-inputs">
                <form>
                  <Select
                    name="myselect"
                    label="Customer Account"
                    value={selectedOption}
                    onChange={(e) => setSelectedOption(e.target.value)}
                    options={options}
                  />
                  <Input
                    name="sendAmount"
                    label="Enter Transfer Amount"
                    value={inputValue}
                    // onChange={(e) => setInputValue(e.target.value)}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      // Allow empty string for deletion or only non-negative numbers
                      if (newValue === "" || (!isNaN(newValue) && Number(newValue) >= 0)) {
                        setInputValue(newValue);
                      } else {
                        setAlert({
                          show: true,
                          message: "Please enter a valid amount.",
                          severity: "error",
                          header: "Error!",
                        })
                      }
                    }}
                    textAlign={"left"}
                    onBlur={() => calculateFee()}
                    type="number"
                    // error={!inputValue}
                    // errorMessage={!inputValue && "Please enter a value to be sent"}
                  />
                  <Box className="info-box">
                    <Box className="sender-name d-flex justify-content-end gap-2 align-items-center">
                      Sender Name: <Box className="info-box-info">{decodeHtmlEntities(senderName)}</Box>
                    </Box>
                    <Box className="fee d-flex justify-content-end gap-2 align-items-center">
                      Recipient Name:{" "}
                      <Box className="info-box-info">{recipientName}</Box>
                    </Box>
                    <Box className="fee d-flex justify-content-end gap-2 align-items-center">
                      Fee: <Box className="info-box-info">${fee.toFixed(2)}</Box>
                    </Box>
                    <Box className="total d-flex justify-content-end gap-2 align-items-center">
                      Total:{" "}
                      <Box className="info-box-info">${total.toFixed(2)}</Box>
                    </Box>
                  </Box>
                  <Stack spacing={receiptID !== "" ? 2 : 1} direction="row" className="button-group d-flex justify-content-end mt-3">
                    <BaseButton 
                      onClick={(e) => {pin ? handleSendDeposit(e, pin) : pinConfiguration === "never" ? handleSendDeposit(e, '0000') : handleTransferButton()}} 
                      // disabled={disabled} 
                      buttonText={"Transfer"} 
                    />
                    {receiptID !== "" ? <BaseButton 
                      buttonText={"Receipt"} 
                      buttonStyle="secondary-button-style"
                      onClick={() => {handleReceipt()}}
                    /> : null}
                  </Stack>
                </form>
              </Box>
            </Box>
          </Box>
      )}
      
      <CustomAlert 
        severity={alert.severity} 
        show={alert.show} 
        header={alert.header} 
        message={alert.message} 
        onClick={() => {
          setAlert({...alert, show:false})
          setFormValues({
            firstName: "",
            lastName: "",
            address: "",
            recipientctry: "",
            email: "",
            phoneNo: "",
          });
        }}
        alertType={alert.type}
        additionalInformation={alert.additionalInformation}
        handleSMSEmail={handleSMSEmail}
        autoclose={alert.severity === "error" ? false : true}
        // autoclose={false}
      />
      {showPinPad && 
        <PinPad 
          show={showPinPad} 
          handleConfirm={handleConfirm} 
          onClick={() => {setAlert({...alert, type: "" }); setShowPinPad(false)}} 
        />
      }
    </Box>
  );
}

export default LocalTransfers;
